/** Dispatched by any trigger (e.g. the mobile header icon) that wants to open
 * the single always-mounted CartDropdown instance without owning its state. */
export const CART_DRAWER_OPEN_EVENT = "ukss:open-cart-drawer"

export const CART_PROMO_SLIDES = [
  {
    id: 1,
    text: "10% Off All Orders!",
    highlight: "TAKE10%",
    cta: "Enter at basket",
  },
  {
    id: 2,
    text: "Free Delivery on Orders Over £75",
    cta: "Shop now",
  },
  {
    id: 3,
    text: "Personalise Any Shirt with Name & Number",
    cta: "Add at product page",
  },
]

/** Stub free delivery threshold in minor units (pence/cents). Backend task to make dynamic. */
export const FREE_DELIVERY_THRESHOLD = 7500

export interface MysteryBoxSizeOption {
  value: string
  label: string
}

export interface MysteryBoxItem {
  id: number
  name: string
  price: number
  image: string
  sizes: MysteryBoxSizeOption[]
  popular?: boolean
}

const MYSTERY_BOX_SIZES: MysteryBoxSizeOption[] = [
  { value: "S", label: "S Adults" },
  { value: "M", label: "M Adults" },
  { value: "L", label: "L Adults" },
  { value: "XL", label: "XL Adults" },
  { value: "2XL", label: "XXL Adults" },
]

export const MYSTERY_BOX_PRODUCTS: MysteryBoxItem[] = [
  {
    id: 9001,
    name: "Mystery Football Grab Bag",
    price: 9.99,
    image: "/images/products/product-new-img-01.png",
    sizes: MYSTERY_BOX_SIZES,
    popular: true,
  },
  {
    id: 9002,
    name: "Mystery Football Grab Bag",
    price: 9.99,
    image: "/images/products/product-new-img-02.png",
    sizes: MYSTERY_BOX_SIZES,
    popular: true,
  },
]
